/**
 * CalculateApplicationContainer
 * --
 */
import React from 'react';
import CalculateApplicationPresenter from './CalculateApplicationPresenter';

const CalculateApplicationContainer = () => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <>
      <CalculateApplicationPresenter />
    </>
  );
};

export default CalculateApplicationContainer;
